import React, { ReactNode, useCallback, useRef, useState } from "react";
import CompanyProfileTabs, { CompanyProfileTab } from "./CompanyProfileTabs";
import PublicCompanyProfile from "./PublicCompanyProfile";
import { CompanyRadarRole } from "reducers/companyProfileApi";

interface InformationTabsLayoutProps {
  children: ReactNode;
  canEditAvatar?: boolean;
  companyCode?: string;
  onReturnToInfo?: () => void;
  profileOnly?: boolean;
  role: CompanyRadarRole;
}

const PublicProfileOnlyHeader = () => (
  <nav
    aria-label="公開プロフィール"
    className="flex h-[46px] w-full border-b border-[#d5d5d5]"
  >
    <div className="relative h-[46px] px-[25px] pb-[12px] pt-[8px] text-[16px] font-bold leading-[1.6] text-[#1b4b86]">
      公開プロフィール
      <span className="absolute bottom-0 left-0 h-[4px] w-full rounded-[2px] bg-[#1b4b86]" />
    </div>
  </nav>
);

const InformationTabsLayout = ({
  children,
  canEditAvatar = false,
  companyCode,
  onReturnToInfo,
  profileOnly = false,
  role,
}: InformationTabsLayoutProps) => {
  const [activeTab, setActiveTab] = useState<CompanyProfileTab>("info");
  const previousTabRef = useRef<CompanyProfileTab | null>(null);
  const handleTabChange = useCallback(
    (tab: CompanyProfileTab) => {
      if (previousTabRef.current === "profile" && tab === "info") {
        onReturnToInfo?.();
      }

      previousTabRef.current = tab;
      setActiveTab(tab);
    },
    [onReturnToInfo],
  );

  return (
    <div className="self-stretch min-h-[924px] overflow-hidden bg-white p-[20px] pb-[100px] md:p-10">
      {profileOnly ? (
        <PublicProfileOnlyHeader />
      ) : (
        <CompanyProfileTabs onTabChange={handleTabChange} />
      )}
      {!profileOnly && (
        <div className={activeTab === "info" ? "mt-[30px]" : "hidden"}>
          {children}
        </div>
      )}
      {(profileOnly || activeTab === "profile") && (
        <div className="mt-[30px]">
          <PublicCompanyProfile
            canEditAvatar={canEditAvatar}
            companyCode={companyCode}
            role={role}
          />
        </div>
      )}
    </div>
  );
};

export default InformationTabsLayout;
